"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriorityText = exports.getPriorityColor = exports.isJson = exports.propertyReverseSorter = exports.propertySorter = exports.hasNumberData = exports.hasNumberDataOld = exports.colorFiller = exports.textifyForPdf = exports.textifyForFront = exports.glasgowScoreValue = exports.sortSurv = exports.computePam = exports.emptyishTab = exports.convertNumToMinSec = exports.multiselect2check = exports.multitristate2text = exports.multiselect2text = exports.multitristate2object = exports.multiselect2object = exports.tristateValue = exports.getBit = exports.unwrapValue = exports.boolToChar = exports.isoIsValid = exports.fmtTime = exports.viewHasContent = exports.hasPerm = exports.NEGATIVE_FLOAT_ARRAY = exports.NEGATIVE_ARRAY = exports.ZERO_ARRAY = exports.EMPTY_STRING_ARRAY = void 0;
const luxon_1 = require("luxon");
const data_1 = require("./data");
exports.EMPTY_STRING_ARRAY = [''];
exports.ZERO_ARRAY = [0, '0'];
exports.NEGATIVE_ARRAY = [-1, '-1'];
exports.NEGATIVE_FLOAT_ARRAY = [-1.0, '-1.0'];
/**
 * Allows to check if the current user has a permission
 * @param {*} currentUser
 * @param {*} requestedPermissionKey
 */
const hasPerm = (currentUser, requestedPermissionKey) => {
    const userPermissions = currentUser.permissions || [];
    return userPermissions.find(p => p.key === requestedPermissionKey || p === requestedPermissionKey) != null;
};
exports.hasPerm = hasPerm;
const viewHasContent = (spec, bilan, adaptative, currentUser = null) => {
    switch (spec['@type']) {
        case 'grid':
        case 'card':
        case 'disclosure':
        case 'category':
        case 'permission':
        case 'tableItem':
            if (currentUser) {
                if (spec['permission']) {
                    let temp = false;
                    for (const perm of spec['permission']) {
                        if (perm[0] === '!' && (0, exports.hasPerm)(currentUser, perm.substring(1)))
                            return null;
                        if ((0, exports.hasPerm)(currentUser, perm) || (perm[0] === '!' && !(0, exports.hasPerm)(currentUser, perm.substring(1))))
                            temp = true;
                    }
                    return temp;
                }
            }
            return (spec.children || []).some(spec => (0, exports.viewHasContent)(spec, bilan, adaptative));
        case 'uuid-string':
        case 'link':
        case 'text':
        case 'time':
        case 'date':
        case 'dateTimeV2':
        case 'tristate':
            if (adaptative)
                return !exports.emptyishTab.includes((0, exports.unwrapValue)(spec, bilan));
            return true;
        case 'dateTime': {
            const unwrap = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return !exports.emptyishTab.includes(unwrap?.time) || !exports.emptyishTab.includes(unwrap?.date);
            return true;
        }
        case 'lesionnel':
        case 'surveillances':
        case 'multiparam':
        case 'selectEditable':
            return true;
        case 'medicaments':
            if (adaptative)
                return (0, exports.unwrapValue)(spec, bilan).length > 0;
            return true;
        case 'integer': {
            const integerValue = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return integerValue != null && integerValue !== '' && Number.isNaN(integerValue) === false;
            return true;
        }
        case 'uuid-array':
        case 'array':
        case 'table': {
            const unwrapArray = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return unwrapArray.length > 0;
            return true;
        }
        case 'floatTime': {
            const floatTimeValue = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return !exports.emptyishTab.includes(floatTimeValue) && floatTimeValue !== 0;
            return true;
        }
        case 'select': {
            const selectValue = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return (!exports.emptyishTab.includes(selectValue) &&
                    Number.isNaN(selectValue) === false &&
                    (spec.options || []).find(opt => opt.value === selectValue) != null);
            return true;
        }
        case 'selectDouble': {
            const selectDoubleValue = (0, exports.unwrapValue)(spec, bilan);
            const selectDoubleValueBis = (0, exports.unwrapValue)(spec, bilan, 'valueBis');
            if (adaptative)
                return (!exports.emptyishTab.includes(selectDoubleValue) &&
                    Number.isNaN(selectDoubleValue) === false &&
                    (spec.options || []).find(opt => opt.value === selectDoubleValue) != null &&
                    !exports.emptyishTab.includes(selectDoubleValueBis) &&
                    Number.isNaN(selectDoubleValueBis) === false &&
                    (spec.options || []).find(opt => opt.value === selectDoubleValueBis) != null);
            return true;
        }
        case 'multiselect': {
            const multiselectValue = (0, exports.unwrapValue)(spec, bilan);
            if (adaptative)
                return (!exports.emptyishTab.includes(multiselectValue) &&
                    Number.isNaN(multiselectValue) === false &&
                    (0, exports.multiselect2text)(multiselectValue, spec.options || []) != null);
        }
        case 'multitristate':
            if (adaptative)
                return (0, exports.multitristate2text)(spec.options(bilan) || []) != null;
        case 'multiselectDouble': {
            const multiselectDoubleValue = (0, exports.unwrapValue)(spec, bilan);
            const multiselectDoubleValueBis = (0, exports.unwrapValue)(spec, bilan, 'valueBis');
            if (adaptative)
                return (!exports.emptyishTab.includes(multiselectDoubleValue) &&
                    Number.isNaN(multiselectDoubleValue) === false &&
                    (0, exports.multiselect2text)(multiselectDoubleValue, spec.options || []) != null &&
                    !exports.emptyishTab.includes(multiselectDoubleValueBis) &&
                    Number.isNaN(multiselectDoubleValueBis) === false &&
                    (0, exports.multiselect2text)(multiselectDoubleValueBis, spec.options || []) != null);
            return true;
        }
        default:
            return null;
    }
};
exports.viewHasContent = viewHasContent;
const fmtTime = datetime => datetime == null
    ? 'NR'
    : luxon_1.DateTime.fromISO(datetime).setZone('Europe/Paris').setLocale('fr-fr').toLocaleString({
        hour: '2-digit',
        minute: '2-digit',
    });
exports.fmtTime = fmtTime;
const isoIsValid = dt => {
    return luxon_1.DateTime.fromISO(dt).isValid;
};
exports.isoIsValid = isoIsValid;
const boolToChar = booleanValue => {
    switch (booleanValue) {
        case true:
            return 'y';
        case false:
            return 'n';
        default:
            return 'u';
    }
};
exports.boolToChar = boolToChar;
const unwrapValue = (spec, bilan, value = 'value') => {
    try {
        return spec[value](bilan);
    }
    catch (e) {
        console.error(e);
        return null;
    }
};
exports.unwrapValue = unwrapValue;
const getBit = (n, k) => {
    if (n == null) {
        return false;
    }
    return (n >> k) & 1;
};
exports.getBit = getBit;
const tristateValue = (value, contentInverted) => {
    if (contentInverted) {
        if (value === 'y')
            return 'Non';
        if (value === 'n')
            return 'Oui';
    }
    if (value === 'y')
        return 'Oui';
    if (value === 'n')
        return 'Non';
    if (value === 'u' || value === null || value === undefined)
        return 'NR';
    return value;
};
exports.tristateValue = tristateValue;
const multiselect2object = (value, options) => {
    const parts = [];
    const parsed = parseInt(value, 10);
    for (const option of options) {
        if ((0, exports.getBit)(parsed, option.value) === 1) {
            const color = option.kind === 'negative'
                ? 'red'
                : option.kind === 'positive'
                    ? 'green'
                    : option.kind === 'intermediate'
                        ? 'orange'
                        : '';
            parts.push({
                label: option.label,
                color,
                kind: option.kind,
            });
        }
    }
    if (parts.length === 0)
        return null;
    return parts;
};
exports.multiselect2object = multiselect2object;
const multitristate2object = (options) => {
    const parts = [];
    for (const option of options) {
        if (option.value === 'y') {
            const color = option.kind === 'negative'
                ? 'red'
                : option.kind === 'positive'
                    ? 'green'
                    : option.kind === 'intermediate'
                        ? 'orange'
                        : '';
            parts.push({
                label: option.label,
                color,
                kind: option.kind,
            });
        }
    }
    if (parts.length === 0)
        return null;
    return parts;
};
exports.multitristate2object = multitristate2object;
const multiselect2text = (value, options) => {
    const parts = [];
    const parsed = parseInt(value, 10);
    for (const option of options) {
        if ((0, exports.getBit)(parsed, option.value) === 1) {
            parts.push(option.label);
        }
    }
    if (parts.length === 0) {
        return null;
    }
    return parts;
};
exports.multiselect2text = multiselect2text;
const multitristate2text = (options) => {
    const parts = [];
    for (const option of options) {
        if (option.value === 'y') {
            parts.push(option.label);
        }
    }
    if (parts.length === 0) {
        return null;
    }
    return parts;
};
exports.multitristate2text = multitristate2text;
const multiselect2check = (value, options) => {
    const parts = [];
    const parsed = parseInt(value, 10);
    for (const option of options) {
        if ((0, exports.getBit)(parsed, option.value) === 1) {
            parts.push(option.kind);
        }
    }
    if (parts.length === 0) {
        return 'orange';
    }
    const colors = [];
    parts.map(elem => {
        if (elem?.includes('negative')) {
            colors.push('red');
        }
        else if (elem?.includes('positive')) {
            colors.push('green');
        }
        else if (elem?.includes('intermediate')) {
            colors.push('orange');
        }
        else {
            colors.push('blue');
        }
    });
    return colors;
};
exports.multiselect2check = multiselect2check;
const convertNumToMinSec = number => {
    // Check sign of given number
    const sign = number >= 0 ? 1 : -1;
    // Set positive value of number of sign negative
    number = number * sign;
    // Separate the int from the decimal part
    const minutes = Math.floor(number);
    let decpart = number - minutes;
    const sec = 1 / 60;
    // Round to nearest secondes
    decpart = sec * Math.round(decpart / sec);
    let secondes = Math.floor(decpart * 60) + '';
    // Add padding if need
    if (secondes.length < 2) {
        secondes = '0' + secondes;
    }
    // Concate minutess and secondes
    const time = minutes + ':' + secondes;
    return time;
};
exports.convertNumToMinSec = convertNumToMinSec;
exports.emptyishTab = [
    null,
    'null',
    undefined,
    NaN,
    'NaN',
    -1,
    '-1',
    '',
    'u',
    '-1.0',
    'NÉANT',
    'NR',
    '00000000-0000-0000-0000-000000000000',
];
const computePam = pa => {
    const matches = (pa || '').match(/^(\d{1,3})\/(\d{1,3})$/);
    if (matches == null) {
        return null;
    }
    const systole = parseInt(matches[1], 10);
    const diastole = parseInt(matches[2], 10);
    return Math.round((systole + 2 * diastole) / 3);
};
exports.computePam = computePam;
/** Sorts monitors - First by hours, then by minutes */
const sortSurv = (array, valueGetter) => {
    return array?.sort((left, right) => {
        if (!valueGetter(left) || !valueGetter(right))
            return 0;
        let lhs = luxon_1.DateTime.fromISO(valueGetter(left)).toMillis();
        let rhs = luxon_1.DateTime.fromISO(valueGetter(right)).toMillis();
        if (isNaN(lhs))
            lhs = 0;
        if (isNaN(rhs))
            rhs = 0;
        return lhs < rhs ? -1 : 1;
    });
};
exports.sortSurv = sortSurv;
const glasgowScoreValue = (y, v, m) => {
    const parsedY = parseInt(y || 0, 10);
    const parsedV = parseInt(v || 0, 10);
    const parsedM = parseInt(m || 0, 10);
    if (Number.isNaN(parsedY) ||
        parsedY <= 0 ||
        Number.isNaN(parsedV) ||
        parsedV <= 0 ||
        Number.isNaN(parsedM) ||
        parsedM <= 0) {
        return null;
    }
    const glaScore = parsedY + parsedV + parsedM;
    return glaScore > 2 ? glaScore : null;
};
exports.glasgowScoreValue = glasgowScoreValue;
const textifyForFront = (mapData, dummy) => {
    return mapData
        .map(([location, label]) => {
        const description_add = [];
        const value = dummy[location] || 0;
        data_1.MANNEQUIN_COLORS.forEach((color, idx) => {
            if ((0, exports.getBit)(value, idx) !== 0)
                description_add.push(color[2]);
        });
        if (description_add.length === 0)
            return null;
        return [location, `${label} : ${description_add.join(', ')}`];
    })
        .filter(el => el != null);
};
exports.textifyForFront = textifyForFront;
const textifyForPdf = (mapData, dummy) => {
    if (dummy == null)
        return '';
    return mapData
        .map(([location, label]) => {
        const description_add = [];
        const value = dummy[location] || 0;
        data_1.MANNEQUIN_COLORS.forEach((color, idx) => {
            if ((0, exports.getBit)(value, idx) !== 0)
                description_add.push(color[2]);
        });
        if (description_add.length === 0)
            return;
        return `<em>${label}</em> : ${description_add.join(', ')}`;
    })
        .filter(el => el != null)
        .join(' // ');
};
exports.textifyForPdf = textifyForPdf;
const colorFiller = value => {
    if (value?.colorFiller.length > 0) {
        return `url(#${value.colorFiller})`;
    }
    return 'url(#Vide)';
};
exports.colorFiller = colorFiller;
/** Checks if the object has a valid number value */
const hasNumberDataOld = o => {
    if (!o)
        return false;
    for (const v of Object.values(o)) {
        if (typeof v === 'number' && v > 0) {
            return true;
        }
    }
    return false;
};
exports.hasNumberDataOld = hasNumberDataOld;
/** Checks if the object has a valid number value */
const hasNumberData = o => {
    if (!o)
        return false;
    for (const v of Object.values(o)) {
        // @ts-ignore
        if (typeof v.value === 'number' && v.value > 0) {
            return true;
        }
    }
    return false;
};
exports.hasNumberData = hasNumberData;
const propertySorter = propertyName => (a, b) => a[propertyName] < b[propertyName] ? -1 : a[propertyName] > b[propertyName] ? 1 : 0;
exports.propertySorter = propertySorter;
const propertyReverseSorter = propertyName => (a, b) => b[propertyName] < a[propertyName] ? -1 : b[propertyName] > a[propertyName] ? 1 : 0;
exports.propertyReverseSorter = propertyReverseSorter;
const isJson = str => {
    try {
        return JSON.parse(str) && !!str;
    }
    catch (e) {
        return false;
    }
};
exports.isJson = isJson;
const getPriorityColor = (bilan) => {
    if (bilan.priorisation === null && bilan.priorisation_v2 === null)
        return 'backgroundColor';
    if (bilan.priorisation !== null) {
        switch (bilan.priorisation) {
            case 1:
                return 'backgroundColor';
            case 2:
                return 'yellow';
            case 3:
                return 'red';
            case 4:
                return 'green';
            default:
                return 'backgroundColor';
        }
    }
    else {
        switch (bilan.priorisation_v2) {
            case '6fb2efcf-40cd-472a-8eb4-7c4383274977':
                return 'backgroundColor';
            case '15ca14fb-09f1-4724-b4b7-f3e49772a939':
                return 'yellow';
            case '454b6bb0-bcc6-4dad-b589-94e142dfd46e':
                return 'red';
            case '260ace70-a31e-4e9e-8d19-f9f9f4be43c1':
                return 'green';
            default:
                return 'backgroundColor';
        }
    }
};
exports.getPriorityColor = getPriorityColor;
const getPriorityText = (bilan) => {
    if (bilan.priorisation === null && bilan.priorisation_v2 === null)
        return 'Bilan blanc';
    if (bilan.priorisation !== null) {
        switch (bilan.priorisation) {
            case 1:
                return 'Bilan blanc';
            case 2:
                return 'Bilan jaune';
            case 3:
                return 'Bilan rouge';
            case 4:
                return 'Bilan vert';
            default:
                return 'Bilan blanc';
        }
    }
    else {
        switch (bilan.priorisation_v2) {
            case '6fb2efcf-40cd-472a-8eb4-7c4383274977':
                return 'Bilan blanc';
            case '15ca14fb-09f1-4724-b4b7-f3e49772a939':
                return 'Bilan jaune';
            case '454b6bb0-bcc6-4dad-b589-94e142dfd46e':
                return 'Bilan rouge';
            case '260ace70-a31e-4e9e-8d19-f9f9f4be43c1':
                return 'Bilan vert';
            default:
                return 'Bilan blanc';
        }
    }
};
exports.getPriorityText = getPriorityText;
